import { Site } from '../home.page.jsx';
import './legal.css';

export default function ImpressumPage() {
    return (
        <div className="legal-content">
            <h1>Impressum</h1>
            <h3>Angaben gemäß § 5 TMG:</h3>
            <p>Leonard Nürnberg<br />
            Heinrich-Narjes Str. 34<br />
            67346 Speyer<br />
            </p>

            <h3>Umsatzsteuer-Identifikationsnummer nach §27a Umsatzsteuergesetz</h3>
            <p>DE349619182</p>

            <h3>Kontakt</h3>
            <p>Telefon: +49 1769 55 030 36</p>
            <p>E-Mail: info@mhub-cloud.de</p>
        </div>
    );
}

ImpressumPage.layout = page => <Site>{ page }</Site>
